import { module } from 'modujs';
import gsap from "gsap";
import { $body } from '../utils/dom';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.addEventListener('p-loaded', () => {
            setTimeout(() => {
                this.initTL();
            }, 400);
        });
        window.addEventListener('p-animate', () => {
            this.animate();
        });
    }

    initTL() {
        this.TL = gsap.timeline({ paused: true });
        this.TL.add(this.animateLogo());
        
        if ($body.classList.contains('home')) {
            this.TL.add(this.animateHome(), '-=0.7');
        }
        else if ($body.classList.contains('single-realisation')) {
            this.TL.add(this.animateRealisation(), '-=0.7');
        }
        else {
            this.TL.add(this.animateDefault(), '-=0.7');
        }
    }

    animate() {
        if (this.TL) {
            this.TL.play();
        }
    }

    animateLogo() {
        let tl = gsap.timeline();

        if (this.el.querySelector('.c-logo')) {
            tl.fromTo(
                this.el.querySelectorAll('.c-logo_letter'),
                { y: '-105%', },
                { y: '0%', duration: 1, ease: 'expo.out', stagger: 0.1 },
                0.2
            );
        }

        return tl;
    }

    animateHome() {
        let tl = gsap.timeline();

        if (this.el.querySelector('.home-mask')) {
            tl.fromTo(
                this.el.querySelector('.home-mask'),
                { opacity: 1 },
                { opacity: 0, duration: 0.6, ease: 'none' },
                0
            );
        }

        if (this.el.querySelector('.o-header_content_tag')) {
            tl.fromTo(
                this.el.querySelector('.o-header_content_tag'),
                { opacity: 0 },
                { opacity: 1, duration: 0.4, ease: 'none' },
                0.2
            );
        }

        if (this.el.querySelector('.o-header_content_inner')) {
            tl.fromTo(
                this.el.querySelector('.o-header_content_inner'),
                { opacity: 0 },
                { opacity: 1, duration: 0.4, ease: 'none' },
                0.3
            );
        }

        return tl;
    }

    animateRealisation() {
        let tl = gsap.timeline();

        if (this.el.querySelector('.realisation_hero_content_inner')) {
            tl.fromTo(
                this.el.querySelector('.realisation_hero_content_inner'),
                { opacity: 0 },
                { opacity: 1, duration: 0.4, ease: 'none' }
            );
        }

        return tl;
    }

    animateDefault() {
        let tl = gsap.timeline();

        let tag = null;

        if (this.el.querySelector('.about-hero_tag')) {
            tag = this.el.querySelector('.about-hero_tag');
        } else if (this.el.querySelector('.o-header_content_tag')) {
            tag = this.el.querySelector('.o-header_content_tag');
        }
        
        if (tag) {
            tl.fromTo(
                tag,
                { opacity: 0 },
                { opacity: 1, duration: 0.4, ease: 'none' },
            );
        }

        if (this.el.querySelector('.o-header_content_inner')) {
            tl.fromTo(
                this.el.querySelector('.o-header_content_inner'),
                { opacity: 0 },
                { opacity: 1, duration: 0.4, ease: 'none' },
                0.1
            );
        }
        

        // if (this.el.querySelector('.o-header .-surtitle')) {
        //     tl.call(() => {
        //         this.el.querySelector('.o-header .-surtitle').classList.add('is-inview')
        //     }, null, delay);
        //     delay += 0.2;
        // }

        // if (this.el.querySelector('.o-header .-h2')) {
        //     tl.call(() => {
        //         this.el.querySelector('.o-header .-h2').classList.add('is-inview')
        //     }, null, delay);
        //     delay += 0.2;
        // }
        
        // if (this.el.querySelector('.o-header .-c2')) {
        //     tl.call(() => {
        //         this.el.querySelector('.o-header .-c2').classList.add('is-inview')
        //     }, null, delay);
        // }

        // tl.call(() => {
        //     this.el.querySelector('.o-page_contents').classList.add('is-inview')
        // }, null, delay);

        return tl;
    }
}
